export default function Problems() {
  const problems = [
    {
      icon: 'ri-time-line',
      title: '作業が終わらない',
      description: '毎日の出品作業や在庫確認に追われ、本来の業務に集中できない'
    },
    {
      icon: 'ri-line-chart-line',
      title: '利益が見えない',
      description: '儲かっている商品が分からず、感覚で仕入れを判断している'
    },
    {
      icon: 'ri-error-warning-line',
      title: '在庫ズレが怖い',
      description: '複数モールで二重販売が発生し、クレームやペナルティのリスク'
    },
    {
      icon: 'ri-calculator-line',
      title: '計算がバラバラ',
      description: '価格・送料・手数料の計算が毎回異なり、正確な利益が把握できない'
    },
    {
      icon: 'ri-user-line',
      title: '任せられない',
      description: '属人化が進み、担当者不在時に業務が止まってしまう'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-3 md:mb-4">
            <i className="ri-emotion-unhappy-line text-2xl md:text-3xl text-gray-400"></i>
            <span className="text-xs md:text-sm font-medium text-gray-600">こんなお悩み、ありませんか?</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            EC運営の<strong className="text-primary">"詰まりポイント"</strong>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-4 md:p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className={`${problem.icon} text-3xl md:text-4xl text-primary`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 text-center mb-2 md:mb-3">
                {problem.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 text-center leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
